<template>
    <div id="wellcome">
        <div style="font-size: 30px;">欢迎来到菲尔斯特！</div>
        <!-- <a href="http://www.festlogistics.com/" target="_blank" style="font-size: 30px;">欢迎来到菲尔斯特！</a> -->
    </div>
</template>
<script>
export default {
    name: 'wellcome',
    //组件创建
    created() {
    },
    mounted(){
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
a {font-size:16px} 
a:link {color: blue; text-decoration:none;} //未访问：蓝色、无下划线 
a:active{color: red; } //激活：红色 
a:visited {color:purple;text-decoration:none;} //已访问：紫色、无下划线 
a:hover {color: red; text-decoration:underline;} //鼠标移近：红色、下划线
</style>